import { Chip, Zoom } from "@mui/material";
import React from "react";
import { SystemFieldProofreadingStatus } from "../../../shared/enums/shared-enums";
import { fieldStatusConfigs } from "../common/status/utils";
import { useFormContext } from "react-hook-form";

interface StatusMetadataChipProps {
  show?: boolean;
  name: string;
}

const StatusMetadataChip: React.FC<StatusMetadataChipProps> = ({
  show = false,
  name,
}) => {
  const { watch } = useFormContext();
  const status = watch(
    `attributes_metadata.${name}.system_proofreading_status`
  );

  const statusConfig =
    fieldStatusConfigs[
      (Object.values(SystemFieldProofreadingStatus).includes(status)
        ? status
        : SystemFieldProofreadingStatus.NO_PROOFREADING) as SystemFieldProofreadingStatus
    ];

  return (
    <Zoom in={show}>
      <Chip
        icon={statusConfig.icon}
        label={statusConfig.label}
        variant="filled"
        color={statusConfig.color}
        size="small"
      />
    </Zoom>
  );
};

export default StatusMetadataChip;
